export default {
  auth_url: "https://clicktotravel-api.veetal.app/auth",
  api_url: "https://clicktotravel-api.veetal.app/api",
  analytics: {
    gaId: "G-FX6E4PGY6F"
  }
};
